import React from 'react';
import { dateToApiString, dateToUTCString, timeRelativeToNow } from 'src/commons';
import { DateLike } from 'src/interfaces/reactInterfaces';
import { CopySpan } from './CopySpan';
import { useDispatch } from 'react-redux';
import { actions, usePreferences } from 'src/data/redux';

/** Displays the given time as either an absolute datetime or a relative datetime, which can be toggled by the user clicking the span.
 * Additionally, a user can copy the API-formatted time string by clicking the included copy button */
export function ToggleableDatetime(props: { children: DateLike; noCopy?: boolean }) {
	// const [isAbsolute, setIsAbsolute] = useState(true);
	const dispatch = useDispatch();
	const { isAbsolute } = usePreferences('datetime');

	return (
		<CopyWrapper datetime={props.children} noCopy={props.noCopy}>
			<span
				style={{ cursor: 'pointer' }}
				onClick={() =>
					dispatch(actions.user.updatePreferences({ key: 'datetime', value: { isAbsolute: !isAbsolute } }))
				}
			>
				{isAbsolute ? dateToUTCString(props.children) : timeRelativeToNow(props.children)}
			</span>
		</CopyWrapper>
	);

	function CopyWrapper(props: { children: JSX.Element; datetime: DateLike; noCopy?: boolean }) {
		if (props.noCopy) {
			return props.children;
		} else {
			return <CopySpan toCopy={dateToApiString(dateToUTCString(props.datetime))}>{props.children}</CopySpan>;
		}
	}
}
